var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.109 51.5274L95.7 42.1279L88.3295 49.532L97.6864 58.9315L105.109 51.5274ZM90.6818 81.2489H75V91.7511H90.6818V81.2489ZM137.727 29H127.273V44.4909H137.727V29V29ZM176.67 49.532L169.3 42.1279L159.943 51.5274L167.314 58.9315L176.67 49.532ZM159.891 121.473L169.248 130.925L176.618 123.521L167.209 114.121L159.891 121.473ZM174.318 81.2489V91.7511H190V81.2489H174.318ZM132.5 54.9931C115.198 54.9931 101.136 69.1187 101.136 86.5C101.136 103.881 115.198 118.007 132.5 118.007C149.802 118.007 163.864 103.881 163.864 86.5C163.864 69.1187 149.802 54.9931 132.5 54.9931ZM127.273 144H137.727V128.509H127.273V144ZM88.3295 123.468L95.7 130.872L105.057 121.42L97.6864 114.016L88.3295 123.468Z",
    fill: "#FFEC65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.194 106.015C133.689 83.1587 113.615 66 89.5 66C70.3537 66 53.725 76.865 45.4437 92.765C25.5025 94.885 10 111.779 10 132.25C10 154.179 27.8213 172 49.75 172H135.875C154.16 172 169 157.16 169 138.875C169 121.385 155.419 107.207 138.194 106.015Z",
    fill: "#F2F2F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.d62d6262c6e7bf4077cba51a196346e8.svg";
export { ForwardRef as ReactComponent };